import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnvil: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="anvil, crafting, hard, strong"><path d="M20.25 4.75H1.75V7.85714L7.4535 10.3888C8.24184 10.7387 8.75 11.5203 8.75 12.3828C8.75 13.377 8.07776 14.2455 7.11526 14.4947L4.75 15.1071V19.25H20.25V15.1071L17.754 14.4608C16.8685 14.2316 16.25 13.4326 16.25 12.5179C16.25 11.6031 16.8685 10.8041 17.754 10.5749L20.25 9.92857V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6 5V9.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAnvil;
